// @owners { team: patients-team }
import { Experimentation } from '@alto/experimentation';
import { useMemo } from 'react';
import { getShipmentsWithItemsByID } from '~shared/features/shipments/selectors/getShipmentsWithItems';
import { getIsFertilityUser } from '~shared/features/users/selectors/getIsFertilityUser';
import { useIsFeatureDisabledForCompany } from '~shared/hooks/useIsFeatureDisabledForCompany';
import { useSelectorShared } from '~shared/store';

type Props = {
  shipmentID?: number;
};

export const useUnboxingGuide = ({ shipmentID }: Props) => {
  const { value: altoEduUnboxingEnabled } = Experimentation.useFeatureFlag('alto_edu_unboxing');
  const shipmentsByID = useSelectorShared(getShipmentsWithItemsByID);
  const fullShipment = shipmentID ? shipmentsByID[shipmentID] : null;
  const isFertilityUser = useSelectorShared((state) => getIsFertilityUser(state, { userID: fullShipment?.user_id }));
  const firstFillPrescriptions = useMemo(() => {
    const prescriptions = fullShipment?.items?.map((item) => item.prescription) || [];
    return prescriptions.filter((prescription) => prescription.refills_used === null);
  }, [fullShipment?.items]);
  const { isFeatureDisabled: isUnboxingGuideDisabledForCompany, isLoading: isFeatureDisablingLoading } =
    useIsFeatureDisabledForCompany('unboxing_guide');
  const showUnboxingGuide =
    !isUnboxingGuideDisabledForCompany &&
    !isFeatureDisablingLoading &&
    altoEduUnboxingEnabled &&
    isFertilityUser &&
    firstFillPrescriptions.length > 0;

  return {
    showUnboxingGuide,
  };
};
